<template>
  <div class="aboutBanner">
    <img :src="bannerImg" alt="" />
    <div class="info aboutBanner-Text whiteIndexTitle">
      <div class="indexTitle">
        <p class="flexItems"><span></span>{{ cnName }}</p>
        <p>{{ enName }}</p>
      </div>
      <!-- <div class="aboutTitle">
        {{ bannerText }}
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["bannerImg", "bannerText", "cnName", "enName"],
};
</script>
<style scoped="scoped">
/* 子页面banner */
.aboutBanner {
  width: 100%;
  position: relative;
}
.aboutBanner img {
  width: 100%;
}
.aboutBanner .aboutBanner-Text {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.aboutBanner .indexTitle {
  position: absolute;
  bottom: 80px;
  left: 0;
}
.aboutBanner .aboutTitle {
  font-size: 64px;
  color: #000;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0%);
}

@media only screen and (max-width: 1440px) {
}
@media only screen and (max-width: 750px) {
  .aboutBanner {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page_banner.vue